import type { RefereeStats } from '@proref/types';
import { api, unwrap, type Envelope } from '../lib/api';

// The signed-in referee's personal stat-card summary (clips answered, overall rule accuracy, and
// their weakest rule), derived server-side from user_mastery. Scoped to the caller by their JWT.
export async function getRefereeStats(): Promise<RefereeStats> {
  const res = await api.get<Envelope<RefereeStats>>('/me/stats');
  return unwrap(res.data);
}
